.rows {
  position: relative;
  width: 100%;
}

/* The box spans one whole STRIDE — the same distance the virtualizer offsets each row by — and
   pays the gap out as bottom padding, leaving a content box of `--gantt-row-height`. Before this,
   `.row` was `height: var(--gantt-row-height)` and the separation was whatever the JS stride
   happened to leave over: `--gantt-row-gap` had no CSS consumer anywhere in the module. */
.row {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  height: var(--gantt-row-stride);
  padding-block-end: var(--gantt-row-gap);
}

.track {
  position: relative;
  flex: 0 0 var(--gantt-range-width);
  width: var(--gantt-range-width);
  height: 100%;
}
